import { cpfValidator } from 'utils/cpf-validator';

const CNPJ_LENGTH = 14;
const CPF_LENGTH = 11;

export const pixKeyFormatter = (value: string): string => {
  if (!value) return '';

  const hasLetters = /[a-zA-Z]/.test(value);
  if (hasLetters || value.length > CNPJ_LENGTH) {
    return value;
  }

  const onlyDigits = value.replace(/\D/g, '');

  if (onlyDigits.length === CNPJ_LENGTH) {
    return onlyDigits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  if (onlyDigits.length === CPF_LENGTH) {
    if (cpfValidator(onlyDigits)) {
      return onlyDigits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    }
    return onlyDigits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
  }

  return value;
};
